import { APIUsageChart } from './APIUsageChart';
import { APIUsageReport } from './APIUsageReport';

export const APIUsagePage = () => {
  return (
    <div className="space-y-8">
      <APIUsageChart />
      <APIUsageReport />
    </div>
  );
};
